<div class="detail-list">
  <mat-grid-list class="detail-grid-list" [cols]="colAmount" [rowHeight]="rowHeight">
    <mat-grid-tile class="detail-grid-tile" *ngFor="let detailRow of detailList">
      {{detailRow.key}}: {{detailRow.value}}
    </mat-grid-tile>
  </mat-grid-list>
</div>
